export class LotWiseInfoModel{
    lotWisePoInfo : lotWisePoInfoModel[];
    lotWiseQtyInfo : lotWiseQtyInfoModel[]

    constructor(lotWisePoInfo:lotWisePoInfoModel[],lotWiseQtyInfo:lotWiseQtyInfoModel[]){
        this.lotWisePoInfo = lotWisePoInfo
        this.lotWiseQtyInfo = lotWiseQtyInfo
    }
}

export class lotWisePoInfoModel {
    date: any;
    lotNumber : string;
    variety : string;
    packing : string;
    grade : string;
    cartons : number;
    loosePouches : number;
    poNumber : string;
    brand : string;
    section : string;
    productionLocation : string;
    productCategory : string;
    qty : number;

    constructor(date: any,lotNumber : string,variety : string,packing : string,grade : string,cartons : number,loosePouches : number,poNumber : string,brand : string,section : string,productionLocation : string,productCategory : string,qty : number){
    this.date = date
    this.lotNumber  = lotNumber 
    this.variety  = variety 
    this.packing  = packing 
    this.grade  = grade 
    this.cartons  = cartons 
    this.loosePouches  = loosePouches 
    this.poNumber  = poNumber 
    this.brand  = brand 
    this.section  = section 
    this.productionLocation  = productionLocation 
    this.productCategory  = productCategory 
    this.qty  = qty 
    }
}

export class lotWiseQtyInfoModel { 
    purhcaseDate : any;
    lotNumber : string;
    honQty : number;
    count : number;
    hlQty : number;
    peelingQty : number;
    soakingInQty : number;
    soakOutQty : number;
    product : string;

    constructor(purhcaseDate : any,lotNumber : string,honQty : number,count : number,hlQty : number,peelingQty : number,soakingInQty : number,soakOutQty : number,product : string){
    this.purhcaseDate  = purhcaseDate 
    this.lotNumber  = lotNumber 
    this.honQty  = honQty 
    this.count  = count 
    this.hlQty  = hlQty 
    this.peelingQty  = peelingQty 
    this.soakingInQty  = soakingInQty 
    this.soakOutQty  = soakOutQty 
    this.product  = product 

    }
}